export default () => {
  	(function(window, document, $) {

		jQuery(document).ready(function($) {

			if ($('.wpg-campaign-sticky-top-wrapper').length) {
				var sticky = new Waypoint({
					element: $('.wpg-header-block-buttons'),
					handler: function(direction) {
						var top = 0;
						if ($('.wpg-usp-top-bar').length) {
							top = $('.wpg-usp-top-bar').outerHeight();
						}

						if (direction === 'down') {
							$('.wpg-campaign-sticky-top-wrapper .wpg-sticky-bar').css({top: top}); //for desktop
							$('.wpg-campaign-sticky-bottom-wrapper .wpg-sticky-bar').css({bottom: 0}); //for mobile
						} else {
							$('.wpg-campaign-sticky-top-wrapper .wpg-sticky-bar').css({top: ($('.wpg-sticky-bar').outerHeight() * -1)}); //for desktop
							$('.wpg-campaign-sticky-bottom-wrapper .wpg-sticky-bar').css({bottom: ($('.wpg-sticky-bar').outerHeight() * -1)}); //for mobile
						}

						$('.wpg-campaign-sticky-top-wrapper').toggleClass('stuck'); //for desktop
						$('.wpg-campaign-sticky-bottom-wrapper').toggleClass('stuck'); //for mobile
					},
				});
			}
		});
  	}(window, document, jQuery));
}